export default {
  0: {
    items: 2
  },
  768: {
    items: 3
  },
  1024: {
    items: 4
  }
};